

export default function mapToSave(state:any) {
	return {
		id: state.data.id,
		fontFamily: state.data.fontFamily,
		language: state.data?.language?.value ? state.data?.language?.value : null,
		active: state.data.active,

		fontStyle: state.data?.fontStyle?.map((item:any) => ({
			style: item.id,
			name: item.name,
			url: state.uploadFonts[item.id]
		}) ),

		preview: state.uploadPreview,
		previewStyle: state.data.previewStyle
	}
}